export const requirementsDue = {
    bindings: {
        identifier: '@'
    },
    template: require('./requirements-due.html'),
    controller: 'RequirementsDueController'
};
